import { Box } from "@material-ui/core";
import { SPView } from "components/common/MediaQuery";
import React from "react";

import { StreamingAnnouncement } from "./StreamingAnnouncement";
import { StreamingEventDetailV2 } from "./StreamingEventDetailV2";
import { EventVideoListContainerV2 } from "./StreamingEventDetailVideoListV2";
import { StreamingEventNavigation } from "./StreamingEventNavigation";
import { StreamingLiveEventV2 } from "./StreamingLiveEventV2";
import { StreamingOptions } from "./StreamingOptions";

import type { StreamingType } from "@spwn/types";
import type { FC } from "react";
import type { EventInfo } from "utility";

type Props = {
  eventInfo: EventInfo;
  mainVideoId: string;
  currentVideoId: string;
  streamingType: StreamingType;
  isOpenAnnouncement: boolean;
  isEditingAnnouncement: boolean;
  streamingAnnouncement: string;
  isLiveCommerceEnabled: boolean;
  isLiveEventEnabled: boolean;
  isOpenLiveEvent: boolean;
  isChatAdmin: boolean;
  handleToggleLiveEvent: () => void;
  setWatchVideo: ({ vid, prevVid }: { vid: string; prevVid?: string }) => void;
  setIsEditingAnnouncement: (isEditing: boolean) => void;
  setStreamingAnnouncement: (announcement: string) => void;
  handleToggleAnnouncement: () => void;
  handleClickCommentNavigation: () => void;
  handleClickGoodsNavigation: () => void;
  onStreamingAnnouncementLocalDeleted: () => void;
};

const StreamingSummaryColumn: FC<Props> = ({
  eventInfo,
  mainVideoId,
  currentVideoId,
  streamingType,
  isOpenAnnouncement,
  isEditingAnnouncement,
  streamingAnnouncement,
  isLiveCommerceEnabled,
  isLiveEventEnabled,
  isOpenLiveEvent,
  isChatAdmin,
  handleToggleLiveEvent,
  setWatchVideo,
  setIsEditingAnnouncement,
  setStreamingAnnouncement,
  onStreamingAnnouncementLocalDeleted,
  handleToggleAnnouncement,
  handleClickCommentNavigation,
  handleClickGoodsNavigation,
}) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gridGap={"16px"}
      padding={"16px"}
    >
      <StreamingOptions
        showAnnouncement={isChatAdmin || streamingAnnouncement !== ""}
        handleToggleAnnouncement={handleToggleAnnouncement}
        handleToggleLiveEvent={handleToggleLiveEvent}
        isLiveEventEnabled={isLiveEventEnabled}
      />

      <SPView>
        {isOpenLiveEvent && <StreamingLiveEventV2 />}

        <StreamingAnnouncement
          eventId={eventInfo.eventId}
          mainVideoId={mainVideoId}
          streamingType={streamingType}
          isOpenAnnouncement={isOpenAnnouncement}
          isEditingAnnouncement={isEditingAnnouncement}
          setIsEditingAnnouncement={setIsEditingAnnouncement}
          streamingAnnouncement={streamingAnnouncement}
          setStreamingAnnouncement={setStreamingAnnouncement}
          onStreamingAnnouncementLocalDeleted={
            onStreamingAnnouncementLocalDeleted
          }
        />
      </SPView>

      <StreamingEventDetailV2 event={eventInfo} currentVid={currentVideoId} />

      <StreamingEventNavigation
        isLiveCommerceEnabled={isLiveCommerceEnabled}
        showCommentNavigation={!eventInfo.isHiddenStreamingComment}
        handleClickCommentNavigation={handleClickCommentNavigation}
        handleClickGoodsNavigation={handleClickGoodsNavigation}
      />

      <EventVideoListContainerV2
        event={eventInfo}
        currentVid={currentVideoId}
        setWatchVideo={setWatchVideo}
      />
    </Box>
  );
};

export default StreamingSummaryColumn;
